import { QueryClient, UseQueryOptions } from '@tanstack/react-query';

export const fetchCachedStorages = async (
  queryClient: QueryClient,
  queries: UseQueryOptions[],
  force: boolean = false,
) => {
  return await Promise.all(
    queries
      .filter((query) =>
        force
          ? true
          : queryClient.getQueryState(query.queryKey)?.status !== 'success',
      )
      .map(async (query) => {
        if (!force) {
          const data = await queryClient.ensureQueryData({
            ...query,
            queryKey: query.queryKey!,
          });
          return data;
        } else {
          const data = await queryClient.refetchQueries({
            queryKey: query.queryKey!,
            type: 'all',
          });
          return data;
        }
      }),
  );
};